import React, { useEffect, useState } from 'react';
import '../css/AdminPendingProducts.css';
import { API_BASE } from '../config';

const AdminPendingProducts = ({ onStatsUpdate }) => {
  const [pendingProducts, setPendingProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  // 🔄 Fetch all pending approvals from backend catalog
  const fetchPendingItems = async () => {
    try {
      const response = await fetch(`${API_BASE}/api/partners/admin/pending-products`);
      const data = await response.json();
      if (data.success) {
        setPendingProducts(data.data);
      } else {
        setError('Failed to fetch data stream.');
      }
    } catch (err) {
      setError('Network communication error with server.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPendingItems();
  }, []);

  // ⚡ Approve Product Action Handler
  const handleApprove = async (productId) => {
    if (!window.confirm('Are you sure you want to approve this product to go live?')) return;

    try {
      const response = await fetch(`${API_BASE}/api/partners/admin/approve-product/${productId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' }
      });
      const data = await response.json();

      if (data.success) {
        alert('🎉 Product approved and now live on main catalog!');
        fetchPendingItems();
        if (onStatsUpdate) onStatsUpdate();
      } else {
        alert(`❌ Approval failed: ${data.message}`);
      }
    } catch (err) {
      alert('Network Error mapping response.');
    }
  };

  if (loading) return <div style={{ padding: '20px' }}>Loading Verification Queue pipeline...</div>;
  if (error) return <div style={{ color: 'red', padding: '20px' }}>{error}</div>;

  return (
    <div className="admin-table-container">
      <h3 className="admin-table-title">⏳ Pending B2B Product Approvals</h3>
      
      {pendingProducts.length === 0 ? (
        <div className="no-pending-data">🎉 Hooray! No pending product verification requests left.</div>
      ) : (
        <div className="admin-table-wrapper">
          <table className="admin-responsive-table">
            <thead>
              <tr>
                <th>Vendor / Company</th>
                <th>Product Title</th>
                <th>SKU</th>
                <th>Vertical</th>
                <th>Price (₹)</th>
                <th>Stock</th>
                <th>MOQ</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {pendingProducts.map((product) => (
                <tr key={product.id}>
                  <td data-label="Vendor / Company">
                    <strong>{product.Partner?.companyName || 'Unknown Vendor'}</strong>
                  </td>
                  <td data-label="Product Title">{product.Title}</td>
                  <td data-label="SKU"><code>{product.SKU}</code></td>
                  <td data-label="Vertical">
                    <span className="badge-vertical">{product.Vertical}</span>
                  </td>
                  <td data-label="Price">₹{product.Price}</td>
                  <td data-label="Stock">{product.Stock} Pcs</td>
                  <td data-label="MOQ">{product.MOQ}</td>
                  <td>
                    <button 
                      onClick={() => handleApprove(product.id)}
                      className="admin-approve-btn"
                    >
                      ✔ Approve & Live
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default AdminPendingProducts;